import { render, staticRenderFns } from "./hot-keys-win.vue?vue&type=template&id=39d554f2&"
import script from "./hot-keys-win.vue?vue&type=script&lang=js&"
export * from "./hot-keys-win.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports